import { useEffect, useState } from "react";
import { useGetTerminals } from "../../../../../hooks/api/queries/useTerminals";
import { useUrlSearch } from "../../../../../hooks/useUrlSearch";
import { useSelector } from "react-redux";
import { capitalizeFirstLetterOfEachWords } from "../../../../../helpers";

export const useAllIntegratedTerminals = () => {
  const {
    search,
    queries,
    setSearch,
    gotoPage,
    filterBySearch,
    filterByStoreId,
  } = useUrlSearch();
  const [isWebhook, setIsWebhook] = useState(
    search.get("show_webhook_url") ? true : false,
  );
  const { storeList } = useSelector((state) => state.profileDetailsReducer);

  const { data, isLoading: isLoadingTerminals } = useGetTerminals({ queries });

  useEffect(() => {
    if (!search.get("terminal_type")) {
      search.set("terminal_type", "INTERSWITCH");
      setSearch(search, { replace: true });
    }
  }, []);

  return {
    search,
    terminals: data?.data || [],
    metaDetails: data?.meta,
    isLoadingTerminals,
    storeList,
    isWebhook,
    providerName: capitalizeFirstLetterOfEachWords(
      search.get("terminal_type") || "",
    ),
    terminalType: search.get("terminal_type"),
    setIsWebhook,
    gotoPage,
    filterBySearch,
    filterByStoreId,
  };
};
